module.exports = __webpack_public_path__ + "img/venus22.ef5acc86.png";